/** Панель фильтров списка Telegram-аккаунтов (KAN-614). */
import { Button } from '@/components/ui/button';
import { ACCOUNT_FILTERS, type AccountFilter } from '@/lib/telegramAccountList';

interface AccountFiltersProps {
  value: AccountFilter;
  onChange: (filter: AccountFilter) => void;
}

export function AccountFilters({ value, onChange }: AccountFiltersProps): JSX.Element {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Фильтр аккаунтов">
      {ACCOUNT_FILTERS.map((f) => (
        <Button
          key={f.value}
          type="button"
          size="sm"
          variant={value === f.value ? 'default' : 'outline'}
          aria-pressed={value === f.value}
          data-testid={`account-filter-${f.value}`}
          onClick={() => onChange(f.value)}
        >
          {f.label}
        </Button>
      ))}
    </div>
  );
}
